<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
<div class="page-container gray-200">
  <section>
    <div class="content-band max-w1200">
      @if (isDataSyncCompleted) {
        <div class="container">
          @if (cService.stepCount !== 7) {
            <app-contact-verification-stepper></app-contact-verification-stepper>
          }

          @switch (cService.stepCount) {
            @case (1) {
              <app-contact-verification-introduction></app-contact-verification-introduction>
            }
            @case (2) {
              <app-contact-verification-emails></app-contact-verification-emails>
            }
            @case (3) {
              @if (cService.isUserOrgMappingExist || cService.hasOfficeEmail) {
                <app-contact-verification-email-office></app-contact-verification-email-office>
              } @else {
                <app-contact-verification-address></app-contact-verification-address>
              }
            }
            @case (4) {
              @if (cService.isUserOrgMappingExist || cService.hasOfficeEmail) {
                <app-contact-verification-address></app-contact-verification-address>
              } @else {
                <app-contact-verification-phone></app-contact-verification-phone>
              }
            }
            @case (5) {
              @if (cService.isUserOrgMappingExist || cService.hasOfficeEmail) {
                <app-contact-verification-phone></app-contact-verification-phone>
              } @else {
                <app-contact-verification-review-submit></app-contact-verification-review-submit>
              }
            }
            @case (6) {
              <app-contact-verification-review-submit></app-contact-verification-review-submit>
            }
            @case (7) {
              <app-contact-verification-success></app-contact-verification-success>
            }
          }
          <!--<app-contact-verification-nav [stepcount]="cService.stepcount" (stepcountUpdated)="onUpdatedStepcount($event)"></app-contact-verification-nav>-->
        </div>
      }
      @if (cService.contactVerificationFailed) {
        <app-contact-verification-fail></app-contact-verification-fail>
      }
    </div>
  </section>

  <div id="modal-cancel" class="modal-wrapper" role="dialog" aria-labelledby="modal-1-heading"
    aria-describedby="modal-1-description" aria-hidden='true' tabindex="0" target="_blank">
    <div class="modal-body rounded-20 white text-center relative shadow">
      <div class="modal-content">
        <header>
          <div class="modal-title" id="modal-1-heading">
            <i class="fa-solid fa-circle-exclamation"></i> Contact Verification Incomplete
          </div>
        </header>
        <p class="font-14 bold font-gray-700" id="modal-1-description">
          Any updates you have made will not be saved and you will be prompted to begin verification again the next time you access a Department of Education application.  To save your updates you must complete the verification process and click the <b>Submit</b> button on the final step.
          <br />
          Click <b>Continue</b> to proceed to your application and lose your progress, or click Cancel to go back and complete contact verification.
        </p>
        <div class="modal-button-container button-adjust">
          <button id="" title="Cancel" class="modalkill secondary border-red rounded-full hover-red hover-font-white flex-row-reverse mobile" (click)="cService.closeCancelConfirmModal()">
            <div class="btn-txt font-red bold">Cancel</div>
          </button>
          <button title="Continue" class="rounded-full hover-blue-800 black mobile" (click)="cService.continueBackToApplication()">
            <div class="btn-txt font-white">Continue</div>
          </button>
        </div>
      </div>
      <a href="javascript:void(0)" role="button" class="modal_close modalkill" aria-label="Close this window" (click)="cService.closeCancelConfirmModal()">close</a>
    </div>
    <a href="javascript:void(0)" class="modal-outside-trigger modalkill" (click)="cService.closeCancelConfirmModal()"></a>
  </div>
</div>

